<template>
  <div class="account-create">
    <h2>Account Create</h2>
    <form>
      <input
        v-model.trim="account.name"
        type="text"
        placeholder="Company Name"
        required
      /><br />
      <input
        v-model.trim="account.street_address"
        type="text"
        placeholder="Street Address"
        required
      /><br />
      <input
        v-model.trim="account.city"
        type="text"
        placeholder="City"
        required
      /><br />
      <input
        v-model.trim="account.state"
        type="text"
        placeholder="State"
        required
      /><br />
      <input
        v-model.trim="account.postal_code"
        type="text"
        placeholder="Postal Code"
        required
      /><br />
      <input
        v-model.trim="account.country"
        type="text"
        placeholder="Country"
        required
      /><br />
      <button type="button" class="button button-300" @click="createAccount">
        Create Account
      </button>
    </form>
  </div>
</template>

<script>
// @ is an alias to /src
export default {
  data() {
    return {
      account: {
        name: "",
        street_address: "",
        city: "",
        state: "",
        postal_code: "",
        country: ""
      }
    };
  },
  methods: {
    createAccount: function() {
      // this.$store.dispatch('createAccount', this.account);
    }
  }
};
</script>
